import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home as HomeIcon, Layers, BarChart3 } from "lucide-react";

const NAV = [
  { to: "/", label: "Scan", icon: HomeIcon, testid: "nav-scan" },
  { to: "/portfolio", label: "Portfolio", icon: BarChart3, testid: "nav-portfolio" },
  { to: "/collections", label: "Collections", icon: Layers, testid: "nav-collections" },
];

export default function AppShell({ children }) {
  const loc = useLocation();
  return (
    <div className="min-h-screen pb-24 sm:pb-0 sm:pt-20">
      {/* Top nav (desktop + tablet) */}
      <header className="hidden sm:flex fixed top-0 inset-x-0 z-40 h-16 items-center justify-between px-8 backdrop-blur-xl bg-black/60 border-b border-amber-300/15">
        <Link to="/" className="flex items-center gap-2 text-sm tracking-[0.24em] text-amber-300/90" data-testid="brand">
          <span className="text-amber-300">●</span> CARDSNAP <span className="text-white/40">·</span> VALUE
        </Link>
        <nav className="flex items-center gap-2">
          {NAV.map((n) => {
            const active = loc.pathname === n.to || (n.to !== "/" && loc.pathname.startsWith(n.to));
            return (
              <Link
                key={n.to}
                to={n.to}
                data-testid={n.testid}
                className={`px-3 py-1.5 rounded-full text-sm transition flex items-center gap-1.5 ${
                  active
                    ? "bg-amber-400/15 text-amber-200 border border-amber-300/40"
                    : "text-white/60 hover:text-white hover:bg-white/5 border border-transparent"
                }`}
              >
                <n.icon className="w-3.5 h-3.5" />
                {n.label}
              </Link>
            );
          })}
        </nav>
      </header>

      {children}

      {/* Bottom nav (mobile) */}
      <nav className="sm:hidden fixed bottom-0 inset-x-0 z-40 h-16 grid grid-cols-3 bg-black/85 backdrop-blur-xl border-t border-amber-300/15">
        {NAV.map((n) => {
          const active = loc.pathname === n.to || (n.to !== "/" && loc.pathname.startsWith(n.to));
          return (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`${n.testid}-mobile`}
              className={`flex flex-col items-center justify-center gap-0.5 text-[10px] tracking-wider uppercase transition ${
                active ? "text-amber-300" : "text-white/55"
              }`}
            >
              <n.icon className="w-5 h-5" />
              {n.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
